export default {
  welcomeLogin: "欢迎登录",
};
